import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MoreMenuComponent as UiMoreMenuComponent,
  MoreMenuItemComponent,
  MoreMenuNoteComponent,
} from '@lyceo/shared/ui';
import { TranslocoDirective } from '@jsverse/transloco';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faArrowRightFromBracket,
  faMessageExclamation,
  faGear,
  faFileShield,
} from '@fortawesome/pro-regular-svg-icons';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import { Capacitor } from '@capacitor/core';
import { MenuController } from '@ionic/angular/standalone';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';
import { UserFacade } from '@lyceo/homi/user/data-access';

@Component({
  selector: 'homi-more-menu',
  templateUrl: './more-menu.component.html',
  styleUrls: ['./more-menu.component.scss'],
  imports: [
    UiMoreMenuComponent,
    MoreMenuItemComponent,
    MoreMenuNoteComponent,
    TranslocoDirective,
    FaIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreMenuComponent {
  private readonly loginSettingsFacade: LoginSettingsFacade =
    inject(LoginSettingsFacade);
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly menuController: MenuController = inject(MenuController);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly userFacade: UserFacade = inject(UserFacade);

  protected release: string = this.environment.release;
  protected platformString: string = Capacitor.getPlatform();
  protected readonly faArrowRightFromBracket: IconDefinition =
    faArrowRightFromBracket;
  protected readonly faMessageExclamation: IconDefinition =
    faMessageExclamation;
  protected readonly faGear: IconDefinition = faGear;
  protected readonly faFileShield: IconDefinition = faFileShield;

  protected close(): void {
    this.menuController.close('more-menu');
  }

  protected logout(): void {
    this.close();

    this.authFacade.userLogout();
  }

  protected websiteLogout(): void {
    this.close();

    this.loginSettingsFacade.websiteLogout();
  }

  protected async feedback(): Promise<void> {
    this.userFacade.moreMenuFeedbackClicked();
  }
}
